export const formatDate = (date) => {
    if (date) {
        const dateArr = date.split("T")[0].split("-");
        return `${dateArr[2]}.${dateArr[1]}.${dateArr[0]}`;
    }
};
